import React, { useEffect } from 'react'
import { Grid, Typography } from "@mui/material";
import { GrHomeRounded } from "react-icons/gr";
import { AiFillInfoCircle, AiOutlineMenu } from "react-icons/ai";
import { BsChatSquareText } from "react-icons/bs";
import { FaInfoCircle } from "react-icons/fa";
import { FaArrowUp } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useState } from 'react';
import logo from './logo.png'
import logoFooter from './serendepia2.png'
import { SlTrophy } from "react-icons/sl";
import { IoGameControllerOutline } from "react-icons/io5";


import './Layout.css'
import Auth from '../Auth/Auth';

function Layout(props) {
    const [pulse, setPulse] = useState(false);
    const [abrir, setAbrir] = useState(true);
    const [aparecer, setAparcer] = useState(false);
    const [user, setUser] = useState({});
    const [generalData, setGeneralData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/gate/info');
                const data = await response.json();
                setGeneralData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setGeneralData(null);
            } finally {
                // Una vez que se completa la solicitud (ya sea éxito o error), establece isLoading en falso
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const [showPopupAuth, setShowPopupAuth] = useState(false);
    const [type, setType] = useState(0);

    function clickPulsedButton() {
        setPulse(!pulse);
        props.setExpanded(!props.tyExpanded);
        setTimeout(() => {
            if (pulse) {
                setAparcer(true);
            } else {
                setAparcer(false);
            }
        }, 500);
    }
    function togglePopupAuth(type) {
        setShowPopupAuth(!showPopupAuth);
        setType(type);
    }
    function cerrarCanalesRecomendados() {
        setAbrir(!abrir);
    }
    const handleLogout = async () => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("_id");
        window.localStorage.removeItem("avatar");
        window.location.href = "/";
    };
    const getNavDesktop = () => {
        return (
            <Grid
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "105% !important",
                    minHeight: '100vh'
                }}
            >
                {/*ASIDE*/}
                {!props.isMobile &&




                    < Grid
                        style={{
                            width: props.tyExpanded ? "13%" : "4%",
                            transition: "width .2s ease-in-out",
                            border: "1px solid #2a2e38",

                            backgroundColor: "#121418",
                            position: "sticky",
                            top: 0,
                        }}
                    >
                        <Grid
                            style={{
                                padding: props.tyExpanded ? "1.54rem 20px" : "2.28rem 5px",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: props.tyExpanded ? "space-between" : 'center',
                            }}
                        >
                            {/* <i
                onClick={() => clickPulsedButton()}
                style={{
                  cursor: "pointer",
                  fontSize: props.tyExpanded ? "30px" : "30px",
                  zIndex: "1000",
    
                  // transform: expanded === false && "rotate(90deg)",
    
                  color: "#ededed",
                }}
                className="fas fa-bars"
              /> */}
                            {/* <img  src="/images/menu.svg" className="img-bars" /> */}

                            <AiOutlineMenu
                                style={{ color: "white", fontSize: "26px" }}
                                onClick={() => clickPulsedButton()}
                                className="img-bars"
                            />

                            {props.tyExpanded && (
                                <Grid
                                    style={{
                                        display: "flex",
                                        textAlign: "center",
                                        alignItems: "center",
                                        borderRadius: ".375rem",
                                        backgroundColor: "#2a2e38",
                                        width: '60%',
                                        border: "1px solid #343843",
                                    }}
                                    className="contenedor-directos-cat"
                                >
                                    <Link style={{ textDecoration: "none", padding: 0, width: '100%' }} to="/descargas">
                                        <Grid
                                            className="button-casino"
                                            style={{
                                                height: "3rem",
                                                color: "white",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",

                                                padding: ".5rem",
                                                borderRadius: ".375rem",
                                                animation: !props.tyExpanded && "ease-in-out 1.5s linear",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    textShadow: "0 1px 0 #000",
                                                }}
                                            >
                                                Descargas{" "}
                                            </span>
                                        </Grid>
                                    </Link>


                                </Grid>
                            )}
                        </Grid>
                        <Grid>

                            <Grid
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                    borderTop: '1px solid rgb(42, 46, 56)'
                                }}
                            >
                                <ul
                                    style={{
                                        listStyle: "none",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        transition: "all 1s ease",
                                        padding: 0
                                    }}
                                >
                                    <Link
                                        style={{ textDecoration: "none" }}
                                        className="menu-aside-option"
                                        to="/"
                                    >
                                        <li
                                            style={{
                                                color: "white",
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "center",
                                                width: "100% !important",
                                                padding: props.tyExpanded ? "0rem 15px" : "0px",
                                                justifyContent: !props.tyExpanded && "center",
                                                animation: !props.tyExpanded && "ease-in-out 1s linear",
                                            }}
                                            className="item-li"
                                        >
                                            <GrHomeRounded />
                                            {/* <i
                        style={{ position: "relative", fontSize: "20px" }}
                        class="fa fa-home"
                      /> */}
                                            {props.tyExpanded && <span>Inicio</span>}
                                        </li>
                                    </Link>
                                    <Link
                                        style={{ textDecoration: "none" }}
                                        className="menu-aside-option"
                                        to="/rankings"
                                    >
                                        <li
                                            style={{
                                                color: "white",
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "center",
                                                padding: props.tyExpanded ? "0rem 15px" : "0px",
                                                justifyContent: !props.tyExpanded && "center",
                                                animation: !props.tyExpanded && "ease-in-out 1s linear",
                                            }}
                                            className="item-li"
                                        >
                                            {/* <i
                        style={{ position: "relative", fontSize: "20px" }}
                        class="fa fa-search"
                      /> */}
                                            <SlTrophy />

                                            {props.tyExpanded && <span>Rankings</span>}
                                        </li>
                                    </Link>

                                    {/* <Link
                    style={{ textDecoration: "none" }}
                    className="menu-aside-option"
                    to="/plataform/clips"
                  >
                    <li
                      style={{
                        color: "white",
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        padding: props.tyExpanded ? "0rem 15px" : "0px",
                        justifyContent: !props.tyExpanded && "center",
                        animation: !props.tyExpanded && "ease-in-out 1s linear",
                      }}
                      className="item-li"
                    >
                      <AiOutlinePlayCircle />
                      {/* <i
                        style={{ position: "relative", fontSize: "20px" }}
                        class="fas fa-film"
                      /> */}
                                    {/*} {props.tyExpanded && <span>Clips</span>}
                    </li>
                  </Link> */}

                                    <Link
                                        style={{ textDecoration: "none" }}
                                        className="menu-aside-option"
                                        to="/foro"
                                    >
                                        <li
                                            style={{
                                                color: "white",
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "center",
                                                padding: props.tyExpanded ? "0rem 15px" : "0px",
                                                justifyContent: !props.tyExpanded && "center",
                                                animation: !props.tyExpanded && "ease-in-out 3s linear",
                                            }}
                                            className="item-li"
                                        >
                                            <BsChatSquareText />
                                            {/* <i
                        style={{ position: "relative", fontSize: "20px" }}
                        class="fas fa-edit"
                      /> */}
                                            {props.tyExpanded && <span>Foro</span>}
                                        </li>
                                    </Link>



                                    <Link
                                        style={{ textDecoration: "none" }}
                                        className="menu-aside-option"
                                        to="/informacion"
                                    >
                                        <li
                                            style={{
                                                color: "white",
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "center",
                                                padding: props.tyExpanded ? "0rem 15px" : "0px",
                                                justifyContent: !props.tyExpanded && "center",
                                                animation: !props.tyExpanded && "ease-in-out 3s linear",
                                            }}
                                            className="item-li"
                                        >
                                            <FaInfoCircle />

                                            {/* <i
                        style={{ position: "relative", fontSize: "20px" }}
                        class="fas fa-edit"
                      /> */}
                                            {props.tyExpanded && <span>Información</span>}
                                        </li>
                                    </Link>
                                </ul>
                            </Grid>
                            <Grid
                                style={{
                                    backgroundColor: "#080808",
                                    padding: "0.5rem 15px",
                                    borderTop: "1px solid #2a2e38",
                                    borderRight: "1px solid #2a2e38",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                {props.tyExpanded ? (
                                    <>
                                        <Grid
                                            style={{
                                                display: "flex",
                                                width: "100%",
                                                alignItems: "center",
                                                padding: "5px",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <Grid style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <AiFillInfoCircle style={{ color: abrir ? '#cd1009' : "white" }} />
                                                <span
                                                    style={{
                                                        color: abrir ? '#cd1009' : "white",
                                                        fontFamily: "Inter",
                                                        fontWeight: "600",
                                                        fontSize: "13px",

                                                    }}
                                                >
                                                    INFORMACIÓN
                                                </span>
                                            </Grid>
                                            {abrir ?
                                                <FaArrowUp style={{
                                                    color: "white",
                                                    marginLeft: "5px",
                                                    backgroundColor: "#080808",
                                                    cursor: "pointer",
                                                    transform: abrir ? "rotate(0deg)" : "rotate(-180deg)",
                                                    transition: "all 0.5s ",
                                                }}
                                                    onClick={() => cerrarCanalesRecomendados()}
                                                />
                                                :
                                                <FaArrowUp style={{
                                                    color: "white",
                                                    marginLeft: "5px",
                                                    backgroundColor: "#080808",
                                                    cursor: "pointer",
                                                    transform: abrir ? "rotate(0deg)" : "rotate(-180deg)",
                                                    transition: "all 0.5s ",
                                                }}

                                                    onClick={() => cerrarCanalesRecomendados()}
                                                />

                                            }

                                        </Grid>

                                        <Grid
                                            style={{
                                                display: abrir ? "flex" : "none",
                                                flexDirection: "column",
                                                gap: "15px",
                                                maxHeight: abrir ? "100% !important" : "0px !important",
                                                transition: "all 0.5s ease-out",
                                            }}
                                        >
                                            <ul style={{ margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', padding: '5px' }}>
                                                {/* Muestra el elemento solo si isLoading es falso */}
                                                {!isLoading && (
                                                    <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                        {generalData && generalData.jugadoresOnline > 0 ? (
                                                            <span id="pulsatingDot" style={{ marginRight: '5px' }} />
                                                        ) : (
                                                            <span id="pulsatingDotOff" style={{ marginRight: '5px' }} />
                                                        )}
                                                        Server
                                                        {generalData && generalData.jugadoresOnline > 0 ? (
                                                            <span style={{ color: 'green' }}>ONLINE</span>
                                                        ) : (
                                                            <span style={{ color: 'red' }}>MANTENIMIENTO</span>
                                                        )}
                                                    </li>
                                                )}
                                                {/* Muestra un indicador de carga mientras isLoading es verdadero */}
                                                {isLoading && <li style={{ color: 'white' }}>Cargando...</li>}

                                                <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center' }}> <IoGameControllerOutline />Versión: Legendaria</li>
                                                <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center' }}> <IoGameControllerOutline />Experiencia: 500x</li>
                                                <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center' }}> <IoGameControllerOutline />Drop: 40%</li>
                                                <Link to='/informacion' style={{ textDecoration: 'none' }}>
                                                    <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center' }} className='item-hover'> VER MÁS</li>
                                                </Link>
                                            </ul>
                                        </Grid>
                                    </>
                                ) : (

                                    <>
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            style={{ margin: "0 auto" }}
                                            className="icono-recomendados"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M12.002 3.999a2 2 0 0 1 2 2v2L18 6v8l-3.998-2v2a2 2 0 0 1-2 1.999h-8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8zM12 6H4v8h8V6z"
                                                clip-rule="evenodd"
                                                fill="#fff"
                                            ></path>
                                        </svg>

                                    </>

                                )}
                            </Grid>
                        </Grid>
                    </Grid>

                }


                {
                    props.isMobile &&

                    <div className="mobile-menu">
                        <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>

                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }}
                                to="/"
                            >
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>

                                    <GrHomeRounded style={{fontSize: '14px'}} />
                                    <span style={{fontSize: '14px'}}>Inicio</span>
                                </Grid>

                            </Link>
                        </Grid>

                        <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }}
                                to="/rankings"
                            >
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>

                                    <SlTrophy style={{fontSize: '14px'}}/>
                                    <span style={{fontSize: '14px'}}>Rankings</span>
                                </Grid>
                            </Link>

                        </Grid>

                        <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>

                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px'}}
                                to="/foro"
                            >
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>

                                    <BsChatSquareText style={{fontSize: '14px'}} />
                                    <span style={{fontSize: '14px'}}>Foro</span>
                                </Grid>
                            </Link>
                        </Grid>

                        <Grid style={{ display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>

                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }}
                                to="/informacion"
                            >
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>

                                    <FaInfoCircle style={{fontSize: '14px'}} />
                                    <span style={{fontSize: '14px'}}>Informacion</span>
                                </Grid>
                            </Link>

                        </Grid>


                    </div>
                }


                {/* GRID NAV - MAIN */}

                <Grid
                    style={{
                        width: props.tyExpanded ? "90%" : "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        zIndex: 997,
                        flex: 1,
                    }}
                >
                    <Grid>
                        <Grid
                            style={{
                                borderBottom: "1px solid #2a2e38",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: props.isMobile ? "0px 1rem" : "0px 5.8rem",
                                position: "sticky",
                                top: 0,
                                zIndex: 998,
                                backgroundColor: "#080808",
                                width: "102%",
                                gap: props.isMobile && "6px"
                            }}
                        >
                            <Link to="/" style={{ width: props.isMobile ? '60%' : '15%' }}>
                                <img
                                    src={logo}
                                    style={{ width: "100%" }}
                                    alt=""
                                />
                            </Link>

                            {
                                !user.username ?

                                    <Grid style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <h6
                                            onClick={() => togglePopupAuth(0)}
                                            className="button-navbar-login"
                                        >
                                            Ingresar
                                        </h6>
                                        <h6
                                            onClick={() => togglePopupAuth(1)}
                                            className="button-navbar-register"
                                        >
                                            Registrarse
                                        </h6>
                                    </Grid>
                                    :
                                    <Grid>
                                        <Typography style={{ color: 'white' }} onClick={() => handleLogout()}>
                                            {user.username}
                                        </Typography>
                                    </Grid>
                            }
                        </Grid>





                        {/*  */}

                        <Grid style={{ width: "102%", backgroundColor: '#080808' }} >
                            {props.children}

                            {showPopupAuth === true && (
                                <Auth
                                    isMobile={props.isMobile}
                                    typeDefault={type}
                                    closePopup={() => togglePopupAuth()}
                                />
                            )}
                        </Grid>


                    </Grid>
                    {/* FOOTER */}


                    <Grid style={{
                        width: '103%',
                        display: "flex",
                        flexDirection: "column",
                        padding: props.isMobile ? "1rem 0rem" : "1.3rem 5rem",
                        zIndex: 99999,
                        backgroundColor: "rgb(18, 20, 24)",
                        gap: '2rem',
                        position: "relative",
                        bottom: 0
                    }}>
                        <Grid style={{ display: 'flex', alignItems: 'center', width: '98%', flexDirection: props.isMobile && 'column' }}>

                            {/* COLUMNA LOGO */}

                            <Grid style={{ width: props.isMobile ? '100%' : "20%" }}>
                                <Link to="/" style={{ margin: props.isMobile && '0 auto', display: props.isMobile && 'flex', justifyContent: props.isMobile && 'center' }}>
                                    <img
                                        src={logoFooter}
                                        style={{ width: props.isMobile ? '30%' : "60%" }}
                                        alt=""
                                    />
                                </Link>
                            </Grid>
                            {/* COLUMNA SUPPORT*/}

                            <Grid style={{ display: 'flex', alignItems: 'flexStart', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile && 'center' }}>
                                <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000' }}>Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Live Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Help Center</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Game Responsibly</Typography>
                            </Grid>
                            {/* COLUMNA PLATFORM*/}
                            <Grid style={{ display: 'flex', alignItems: 'flexStart', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile && 'center' }}>
                                <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000' }}>Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Live Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Help Center</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Game Responsibly</Typography>
                            </Grid>
                            {/* COLUMNA policy*/}
                            <Grid style={{ display: 'flex', alignItems: 'flexStart', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile && 'center' }}>
                                <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000' }}>Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Live Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Help Center</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Game Responsibly</Typography>
                            </Grid>
                            {/* COLUMNA cOMMUNITY*/}
                            <Grid style={{ display: 'flex', alignItems: 'flexStart', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile && 'center' }}>
                                <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000' }}>Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Live Support</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Help Center</Typography>
                                <Typography style={{ color: '#828998', fontFamily: 'Inter' }}>Game Responsibly</Typography>
                            </Grid>
                            {/* COLUMNA cOMMUNITY*/}
                            <Grid
                                style={{
                                    display: "flex",
                                    alignItems: "flexStart",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    width: props.isMobile ? '40%' : "10%",
                                    color: "white",
                                }}
                            >
                                <select
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "#2a2e38",
                                        borderRadius: "5px",
                                        color: "white",
                                        padding: "10px",
                                    }}
                                    name="cars"
                                    id="cars"
                                >
                                    <option value="Publico"> Español</option>
                                    <option value="Privado"> Inglés</option>
                                </select>
                            </Grid>
                        </Grid>



                    </Grid>
                </Grid>
            </Grid >
        )
    }



    return (
        getNavDesktop()
    )
}

export default Layout